import { render, staticRenderFns } from "./templates.vue?vue&type=template&id=49979a71&scoped=true&"
import script from "./templates.vue?vue&type=script&lang=js&"
export * from "./templates.vue?vue&type=script&lang=js&"
import style0 from "./templates.vue?vue&type=style&index=0&id=49979a71&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49979a71",
  null
  
)

export default component.exports